<template>
    <div class="__l">
        <h1 class="title">Promotions</h1>
        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="createPromotion">Create Promotion</button>
        </div>
        <input type="text" class="form-field py-4 px-6" ref="searchbar" placeholder="Search for Promotions by Code"
               @keyup.enter="handleSearch">
        <div v-if="results.data && search">
            <p>The total number of results for <strong>"{{ search }}"</strong> is <strong>{{ results.total }}</strong>
            </p>
        </div>
        <div v-if="results.data && !search">
            <p>The total number of results is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="30%">Title</div>
                <div class="results-head" data-width="20%">Code</div>
                <div class="results-head" data-width="10%">Discount</div>
                <div class="results-head" data-width="20%">Start Date</div>
                <div class="results-head" data-width="20%">Expiry Date</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectPromotion(result)">
                    <div class="results-cell" data-width="30%">{{ result.title }}</div>
                    <div class="results-cell" data-width="20%">{{ result.code }}</div>
                    <div class="results-cell" data-width="10%" v-if="result.fixed_amount">
                        £{{ result.fixed_amount }}
                    </div>
                    <div class="results-cell" data-width="10%" v-if="!result.fixed_amount">
                        {{ result.percentage * 100 }}%
                    </div>
                    <div class="results-cell" data-width="20%">{{ result.start }}</div>
                    <div class="results-cell" data-width="20%">{{ result.expires }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'Promotions',
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        // PromotionsView,
        Pagination
    },
    mounted() {
        this.loadData()
        this.setMetaTitle('List Promotions | JournoLink Control')
    },
    beforeRouteUpdate(to, from, next) {
        this.loadData()
        next()
    },
    methods: {
        handleSearch(event) {
            this.search = event.target.value
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('promotions.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of a promotion
         *
         * @param  {Object} promotion
         * @return {void}
         */
        handleSelectPromotion(promotion) {
            this.$router.push({name: 'promotions.show', params: {code: promotion.code}})
        },
        /**
         * createPromotion
         */
        createPromotion() {
            this.$router.push({name: 'promotions.create'})
        },
    },
}
</script>

<style lang="less">

</style>
